module.exports = __webpack_public_path__ + "static/media/icon-send-whisky.bf063a72.svg";